const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';
const SET_RECOMMENDATIONS_FAILURE = 'SET_RECOMMENDATIONS_FAILURE';

export {
    SET_RECOMMENDATIONS, SET_RECOMMENDATIONS_FAILURE
};
